import React, { useEffect } from 'react';
import { X, Check } from 'lucide-react';
interface BonusModalProps {
  isOpen: boolean;
  onClose: () => void;
  bonus: {
    title: string;
    subtitle: string;
    image: string;
    details: string[];
    footer: string;
  } | null;
}
export function BonusModal({
  isOpen,
  onClose,
  bonus
}: BonusModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen || !bonus) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-32">
      <div className="absolute inset-0 bg-text-dark/60 backdrop-blur-sm transition-opacity" onClick={onClose} data-id="element-33" />

      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto z-10" data-id="element-34">
        <button onClick={onClose} className="absolute top-4 right-4 p-2 bg-white/10 backdrop-blur-md rounded-full text-white hover:bg-white/20 transition-colors z-20 shadow-sm" aria-label="Cerrar" data-id="element-35">
          <X className="w-5 h-5" data-id="element-36" />
        </button>

        <div className="p-6" data-id="element-37">
          <div className="bg-gradient-to-br from-primary-700 to-primary-600 rounded-xl p-4 mb-6 flex items-center justify-center" data-id="element-38">
            <img src={bonus.image} alt={bonus.title} className="w-full h-auto max-h-64 object-contain drop-shadow-xl" data-id="element-39" />
          </div>

          <h3 className="text-xl font-bold text-text-dark mb-1" data-id="element-40">
            {bonus.title}
          </h3>
          <p className="text-primary-600 font-medium mb-5" data-id="element-41">{bonus.subtitle}</p>

          <ul className="space-y-3 mb-6" data-id="element-42">
            {bonus.details.map((detail, idx) => <li key={idx} className="flex items-start gap-2.5" data-id="element-43">
                <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-44" />
                <span className="text-text-body text-sm leading-relaxed" data-id="element-45">
                  {detail}
                </span>
              </li>)}
          </ul>

          <hr className="border-warm-200 my-4" data-id="element-46" />

          <div className="bg-warm-50 p-3.5 rounded-lg border border-warm-100" data-id="element-47">
            <p className="text-sm text-text-muted italic" data-id="element-48">{bonus.footer}</p>
          </div>
        </div>
      </div>
    </div>;
}